import { useLayoutEffect } from 'react'
import { usePreviousPage } from './usePreviousPage'
import TestIds from '../testIds'

export const useScrollRestoration = <E extends HTMLElement = HTMLElement>({
  ref,
  scrollYPositionKey,
  path,
}: {
  ref: React.RefObject<E>
  scrollYPositionKey: string
  path: string
}): void => {
  const { previousPage } = usePreviousPage()

  useLayoutEffect(() => {
    const clearTimer = setTimeout(() => {
      const element = document.getElementById(TestIds.pages.mainScrollContainer)
      if (element && scrollYPositionKey && previousPage.startsWith(path)) {
        element.scrollTo({
          top: parseInt(scrollYPositionKey) ?? 0,
          behavior: 'auto',
        })
      }
    }, 100)

    return (): void => {
      clearTimeout(clearTimer)
    }
  }, [previousPage, ref])
}
